import { Component, Input } from '@angular/core';
import { LocDisclosureInfo } from '../../apr-calculator.model';

@Component({
    selector: 'ifa-apr-disclosure-ut-lcf',
    templateUrl: './apr-disclosure-ut-lcf.component.html',
    styleUrls: ['../../apr-disclosure.component.scss', './apr-disclosure-ut-lcf.component.scss'],
    standalone: false
})
export class AprDisclosureUtLcfComponent {

    @Input() data: LocDisclosureInfo = new LocDisclosureInfo('', 0, 0, null, null, 0, 0, 0, 0);
}